import { useEffect, useLayoutEffect, useState, Fragment, useRef } from 'react';
import { SelectProps } from "@mui/material/Select";
import { useField } from 'formik';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from "../../commons/store/hooks";
import { fetchAutocomplete, selectAutocomplete } from "../../features/ecrf/redux/elementDataSlice";
import { selectEcrf } from "../../features/ecrf/redux/ecrfSlice";
import { isArray } from "lodash";
import { useMercure } from "utils/mercure";
import { useQueryElements } from "utils/element";
import { Element } from "types/form/Element";

const useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

interface Option {
  id: string;
  value: string;
}

export interface Props {
  size?: "small" | "medium";
  name: string;
  label?: string;
  placeholder?: string;
  fullWidth?: boolean;
  onChange?: (event: any) => any;
}

const AutocompleteElementsField = ({
  size = "medium",
  name,
  label,
  placeholder,
  fullWidth,
  onChange,
  ...props
}: Props) => {
  const dispatch= useAppDispatch()
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<any>(null);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<readonly Option[]>([]);
  const [loading, setLoading] = useState(false);

  // const {
  //   isLoading: isLoading,
  //   data: { data: data, hubURL: hubURL } = { hubURL: null },
  // } = useQueryElements();
  //
  // const collection = useMercure(data, hubURL);
  // const items = collection ? (collection["member"] ?? []) : [];

  useEffect(() => {
    let active = true;

    if (!open || value?.value === inputValue) {
      return undefined;
    }

    setLoading(active);

    (async () => {
        const args = {  };
        const params = {
          label: 'preview',
          // label: inputValue,
          // 'exists[children]': true,
          // 'order[createdAt]': 'desc'
          'order[label]': 'asc'
        };
        const elements = await dispatch(fetchAutocomplete({ link: '/api/elements', args, params })).unwrap();

        if (active) {
            const map = elements?.map((item: any): any => {
                    // const elements: any =  item?.elements?.slice().sort(
                    //     (a: any, b: any) => a.position - b.position
                    // );
                    // if (elements[0] && isArray(elements[0]?.data) && elements[0]?.data[0]) {
                    //     return {
                    //         id: item?.id,
                    //         value: elements[0]?.data[0]
                    //     }
                    // }

                return {
                  label: item?.label,
                  value: item?.id
                }
            });

            setOptions(map);
        }
    })();

    return () => {
        active = false;
        setLoading(active);
    };
  }, [open, value, inputValue, dispatch]);

  return (
      <Autocomplete
          isOptionEqualToValue={(option, value) => option.value === value.value}
          options={options}
          getOptionLabel={(option: any) =>
            typeof option === "string" ? option : option?.label || ""
          }
          filterOptions={(x) => x}
          autoComplete
          includeInputInList
          filterSelectedOptions
          loading={loading}
          value={value || null}
          fullWidth
          // multiple
          onChange={(event, value) => {
            if (onChange) {
              onChange(value);
            }
            setValue(value);
          }}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => { setOpen(false) }}
          onInputChange={(event, value,reason) => {
              setInputValue(value);
          }}
          renderInput={(params) => (
              <TextField
                  {...params}
                  label={label}
                  size={size}
                  fullWidth
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      endAdornment: (
                        <Fragment>
                          {loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </Fragment>
                      ),
                    },
                  }}
              />
          )}
      />
  );
};

export default AutocompleteElementsField;
